import { reactive, watch, computed, toRefs } from '@vue/composition-api';
import { removeNotePages, addNote, moveNotes } from '@/components/ContextDoc/use/useDocActions';
import useClipboard from '@/views/Context/use/useClipboard';
import { buildList } from '@/views/Context/use/useExport';
import { pagesModule } from '@/store/database/pagesModule';
const state = reactive({
  dragSelecting: false,
  selectedPageId: null,
  start: null,
  startOrder: null,
  end: null,
  endOrder: null,
  selectedSpace: null,
  event: null
});

const updateDragSelecting = (v, e) => {
  state.dragSelecting = v;
  state.event = e;
};

const selectedPage = computed(() => {
  console.log('get page');
  return pagesModule.doc(state.selectedPageId).data;
});

const selectedCount = computed(() => {
  return Math.abs(state.startOrder - state.endOrder) + 1;
});

const checkIsSelected = ({ pageId, order = null }) => {
  if (state.selectedPageId != pageId || order == null) return false;
  const min = Math.min(state.startOrder, state.endOrder);
  const max = Math.max(state.startOrder, state.endOrder);
  return order >= min && order <= max;
};

const getSelectedNoteIds = () => {
  const start = state.start;
  const end = state.end;
  if (start && end) {
    const rangeIds = [start, end];
    const page = selectedPage.value ? selectedPage.value : false;
    if (!page) {
      console.log('no page!');
      return [];
    }
    //  Put the range ids in order;
    const rangeDocs = rangeIds
      .map(id => page.pageNotes[id])
      .sort((a, b) => (a.order < b.order ? -1 : 1));

    if (!rangeDocs[0] || !rangeDocs[1]) return [];
    const startOrder = rangeDocs[0].order;
    const endOrder = rangeDocs[1].order;
    //  Get all notes within span
    const noteIds = Object.values(page.pageNotes)
      .filter(p => !p.toDelete && p.order >= startOrder && p.order <= endOrder)
      .sort((a, b) => (a.order < b.order ? -1 : 1))
      .map(n => n.id);
    console.log('got noteids', noteIds);
    return noteIds;
  } else {
    console.log('no note blocks selected');
    return [];
  }
};

watch(
  () => state.selectedPageId,
  (newValue, oldValue) => {
    if (newValue && !oldValue) {
      //  we started drag
      console.log('add copy event listener');
      document.addEventListener('keydown', selectionKeyDownHandler);
      document.addEventListener('copy', copySelectedBlocks);
    } else if (!newValue && !!oldValue) {
      console.log('remove copy event listener');
      document.removeEventListener('keydown', selectionKeyDownHandler);
      document.removeEventListener('copy', copySelectedBlocks);
    }
  }
);

const selectionKeyDownHandler = event => {
  const key = event.which || event.keyCode;
  //  ignore copy
  if (key == 67 && (event.ctrlKey || event.metaKey)) {
    return;
  }
  //  ignore select all (a)
  if (key == 65 && event.ctrlKey) {
    return;
  }

  //  if tab, do nothing and let local template handle
  if (key == 9) {
    return;
  }

  //  Shift up and shift down
  if (key == 38 || key == 40) {
    if (event.shiftKey) {
      const page = selectedPage.value;

      const nextNoteOrder = key == 38 ? state.endOrder - 1 : state.endOrder + 1;
      console.log(nextNoteOrder);
      if (nextNoteOrder < 0) return;

      const nextNote = Object.values(page.pageNotes).find(
        n => n.order == nextNoteOrder && !n.toDelete
      );

      if (nextNote == undefined) return;

      return updateSelectedRange({ end: nextNote.id, endOrder: nextNoteOrder });
    }
    if (event.altKey && event.ctrlKey) {
      //  do nothing now and let local move process happen.
      const amount = key == 38 ? -1 : 1;
      console.log('move ' + amount);
      state.pageRef.moveOrder({ noteId: state.start, event: { amount }, order: state.startOrder, forceMove: true });
      return;
    }
  }

  if (key == 46 || key == 8) {
    //  handle delete
    return deleteSelectedBlocks();
  }

  if (key == 16 || key == 18 || key == 17) {
    //  if just shift, alt, ctrl do nothing
    console.log(key);
    return;
  }

  // otherwise clear selection
  event.preventDefault();
  clearSelection();
};

const copySelectedBlocks = event => {
  event.preventDefault();
  const blockIds = getSelectedNoteIds();
  const page = pagesModule.doc(state.selectedPageId).data;
  let text = '';
  let contents = [];
  let blocks = blockIds.map(id => page.pageNotes[id]);

  blocks = blocks.sort((a, b) => a.order - b.order);
  // blocks.forEach(b => {
  //   try {
  //     // const docRef = this.$refs['cardDoc'];
  //     // console.log(docRef);
  //     // const noteRef = docRef.$refs[b.id][0];
  //     if (b.type == 'note') {
  //       text += b.content.html;
  //     } else if (b.type == 'card') {
  //       text += getPage(b.pageId).value.title;
  //     }
  //     console.log(text);
  //   } catch (e) {
  //     console.log(e);
  //   }
  //   //text += this.$refs[b.id][0].$refs.editor.editor.getText();
  //   contents.push(b.id);
  // });

  //  build the html bulleted list
  const div = document.createElement('div');
  let string = '';
  let ul = document.createElement('ul');
  console.log(blocks);
  blocks.forEach(b => {
    if (!b.pageId) return;
    contents.push(b.id);
    const itemData = buildList(b.pageId);
    ul.appendChild(itemData.li);
    string = string + itemData.string;
    console.log(itemData);
  });
  div.appendChild(ul);
  const html = div.innerHTML;
  const { setClipboard } = useClipboard();
  setClipboard({
    text: string,
    type: 'block',
    blockData: {
      blockIds,
      contents,
      parent: state.selectedPageId
    }
  });
  event.clipboardData.setData('text/plain', string);
  event.clipboardData.setData('text/html', html);
  clearSelection();
};

const updateSelectedRange = ({
  start = undefined,
  startOrder = undefined,
  end = undefined,
  endOrder = undefined,
  pageRef = undefined,
  pageId = undefined,
  space = undefined
}) => {
  console.log('update selected range', pageId, start, end, startOrder, endOrder);
  if (start !== undefined) {
    state.start = start;
  }
  if (startOrder !== undefined) {
    state.startOrder = startOrder;
  }
  if (end !== undefined) {
    state.end = end;
  }
  if (endOrder !== undefined) {
    state.endOrder = endOrder;
  }
  if (pageRef !== undefined) {
    state.pageRef = pageRef;
  }
  if (pageId !== undefined && pageId != state.selectedPageId) {
    state.selectedPageId = pageId;
  }
  if (space !== undefined && space != state.selectedSpace) {
    state.selectedSpace = space;
  }
  console.log(state);
};

const clearSelection = () => {
  console.log('clear selection');
  state.dragSelecting = false;
  state.selectedPageId = null;
  state.start = null;
  state.end = null;
  state.startOrder = null;
  state.endOrder = null;
  state.selectedSpace = null;
  state.event = null;
  document.removeEventListener('keydown', selectionKeyDownHandler);
  document.removeEventListener('copy', copySelectedBlocks);
};

const deleteSelectedBlocks = () => {
  const blockIds = getSelectedNoteIds();
  const pageId = state.selectedPageId;
  console.log(blockIds, pageId);
  blockIds.forEach(b => {
    removeNotePages({ noteId: b, pageId });
  });
  clearSelection();
};

const groupSelectedBlocks = async () => {
  const order = Math.min(state.startOrder, state.endOrder);
  const newPageId = await addNote({
    pageId: state.selectedPageId,
    pageType: 8,
    html: '',
    returnPageId: true,
    order
  });

  //  move allt he selected notes to it
  const noteIds = getSelectedNoteIds();
  moveNotes({
    noteIds,
    moveToPageId: newPageId,
    moveFromPageId: state.selectedPageId,
    moveToPosition: 0
  });
  //  return the new order so we can focus on that new note
  return order;
};

export default function useMultiSelect() {
  return {
    ...toRefs(state),
    updateDragSelecting,
    updateSelectedRange,
    clearSelection,
    copySelectedBlocks,
    deleteSelectedBlocks,
    getSelectedNoteIds,
    selectedCount,
    checkIsSelected,
    groupSelectedBlocks
  };
}
